import _ from 'lodash'
import { useSelector } from 'react-redux'
import isEqual from 'react-fast-compare'
import { dataConstants } from 'services/redux/data/constants'
import ObjectEmployee from 'utils/objects/employee'

const useEmployee = ( guid ) => {
	return useSelector( state => {
		if( !guid ) return undefined;

		const employee = _.merge(
			{},
			state.data[ dataConstants.EMPLOYEES ]?.[ guid ],
			state.data[ dataConstants.EMPLOYEES_DETAILED ]?.[ guid ],
			state.data[ dataConstants.EMPLOYEES_ERO ]?.[ guid ],
			state.data[ dataConstants.EMPLOYEES_CONFIDANTS ]?.[ guid ],
		);

		if( _.isEmpty( employee ) ) return undefined;

		return ObjectEmployee.filterInvisible({ [ guid ]: employee })[ guid ];
	}, isEqual );
}

export default useEmployee
